export const firebaseConfig = {
    apiKey: "AIzaSyCqdXbDb9kmeWUO8dcI0KvN9IJEdA75myg",
    authDomain: "ga-passport.firebaseapp.com",
    databaseURL: "https://ga-passport.firebaseio.com",
    storageBucket: "ga-passport.appspot.com",
    messagingSenderId: "873870846512"
};


// WEBPACK FOOTER //
// ./src/firebase/config.js